import { Stack, useTheme } from '@mui/material';

import { FC } from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { DialogFormDescription } from '../dialog-form/dialog-form-description';

export const SupportedCreditCards: FC = () => {
  const theme = useTheme();

  return (
    <Stack direction='row'>
      <InfoOutlinedIcon
        sx={{
          color: theme.palette.typography.color.muted,
          marginRight: '8px',
          marginTop: '4px',
          width: '24px',
          height: '24px',
        }}
      />
      <DialogFormDescription
        message='my_credit_cards.supported_cards'
        sx={{
          textAlign: 'left',
          marginBottom: 0,
        }}
      />
    </Stack>
  );
};
